<template lang="html">
  <svg class="icon-svg" width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.77111 0.439233L3.8477 0.0952235C4.85652 -0.227126 5.9344 0.293823 6.3664 1.31256L7.2261 3.33991C7.6008 4.22336 7.3929 5.26227 6.7121 5.9084L4.81783 7.70641C4.93471 8.7819 5.2962 9.8409 5.9024 10.8834C6.5085 11.9259 7.2655 12.7907 8.1734 13.4778L10.4486 12.7191C11.311 12.4315 12.2502 12.762 12.7792 13.5392L14.0116 15.3498C14.6265 16.2532 14.5159 17.4995 13.7529 18.2655L12.9352 19.0865C12.1212 19.9036 10.9587 20.2 9.8833 19.8645C7.3444 19.0726 5.0101 16.7214 2.88034 12.8109C0.747469 8.8947 -0.00528082 5.57214 0.622099 2.84313C0.886089 1.69482 1.70361 0.780333 2.77111 0.439233Z" fill="#ADA8A8"/>
  </svg>

</template>
<script>
    export default {
        name: 'IconPhone'
    }
</script>



// WEBPACK FOOTER //
// src/components/icons/IconPhone.vue